import {ChatContextProvider} from "../../../lib/src/chat/context/chat-context";
import {ChatMetadataContextProvider} from "../../../lib/src/chat/context/chat-metadata-context";
import React, {FC} from "react";
import {ConfigInterface} from "../../../lib/src/config";
import {useTeamData} from "../resources/TeamContext";
import {useEmployeesData} from "../resources/EmployeeContext";

interface ChatProviderAdapterProps {
  children: React.ReactNode
  config: ConfigInterface
}
export const ChatProviderAdapter: FC<ChatProviderAdapterProps> = props => {
  const {teams} = useTeamData()
  const {employees} = useEmployeesData()
  return <ChatMetadataContextProvider config={props.config}>
    <ChatContextProvider
      rocketChatWebsocketUrl={`wss://${props.config.rocketChatHostname}/websocket`}
      employees={employees}
      teams={teams}
      config={props.config}
    >
      {props.children}
    </ChatContextProvider>
  </ChatMetadataContextProvider>
}